import { ReactElement } from 'react';

export type FooterLink = {
  href?: string;
  icon?: ReactElement;
  text: string;
};

export type FooterGroup = {
  links: FooterLink[];
  text: string;
};

export enum IconType {
  Email = 'email',
  Phone = 'phone',
}
